import React, { useState } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Layout from './Layout';
import Login from './Login';
import SignUp from './SignUp';
import About from './About';
import Contact from './Contact';
import Dashboard from './Dashboard';

function App() {
  const [isAuthenticated, setIsAuthenticated] = useState(false);

  return (
    <Router>
      <Routes>
        <Route element={<Layout />}>
          {/* مسیرهای عمومی */}
          <Route path="/about" element={<About />} />
          <Route path="/contact" element={<Contact />} />

          {/* اگر لاگین نیست */}
          <Route
            path="/login"
            element={
              !isAuthenticated ? (
                <Login onLogin={() => setIsAuthenticated(true)} />
              ) : (
                <Navigate to="/dashboard" replace />
              )
            }
          />
          <Route
            path="/signup"
            element={
              !isAuthenticated ? (
                <SignUp onSignUp={() => setIsAuthenticated(true)} />
              ) : (
                <Navigate to="/dashboard" replace />
              )
            }
          />

          {/* مسیرهای خصوصی */}
          <Route
            path="/dashboard"
            element={isAuthenticated ? <Dashboard /> : <Navigate to="/login" replace />}
          />

          {/* مسیر پیش‌فرض */}
          <Route
            path="/"
            element={<Navigate to="/about" replace />}
          />
        </Route>
      </Routes>
    </Router>
  );
}

export default App;
